import { __read } from "tslib";
import React, { useState } from 'react';
import classNames from 'classnames';
import { BuyButton } from '../buybutton';
import i18n from '../i18n';
var t = i18n.t;
function BuyDescriptionsItem(_a) {
    var className = _a.className, style = _a.style, label = _a.label, children = _a.children;
    return (React.createElement("li", { className: classNames('buy-descriptions-item', className), style: style },
        React.createElement("div", { className: "buy-descriptions-item-label" }, label),
        React.createElement("div", { className: "buy-descriptions-item-content" }, children)));
}
function BuyDescriptionsProItem(_a) {
    var className = _a.className, label = _a.label, children = _a.children, status = _a.status, style = _a.style;
    return (React.createElement("div", { className: classNames('buy-descriptions-item description-bkg', className, status), style: style },
        React.createElement("div", { className: classNames('buy-descriptions-item-label', status) }, label),
        React.createElement("div", { className: "buy-descriptions-item-content" }, children)));
}
function BuyDescriptionsCollapse(_a) {
    var className = _a.className, style = _a.style, children = _a.children, status = _a.status, _b = _a.visible, visible = _b === void 0 ? true : _b;
    var _c = __read(useState(visible), 2), open = _c[0], setOpen = _c[1];
    return (React.createElement("div", { className: classNames('buy-descriptions-collapse', className, status, { open: open, close: !open }), style: style },
        React.createElement(BuyButton, { type: 'weak', className: 'collapse-switch', onClick: function () { return setOpen(!open); } }, open ? t('收起') : t('展开')),
        children));
}
export function BuyDescriptions(_a) {
    var className = _a.className, style = _a.style, children = _a.children;
    return (React.createElement("div", { className: classNames('buy-descriptions', className), style: style },
        React.createElement("div", { className: "buy-descriptions-body" },
            React.createElement("ul", { className: "buy-descriptions-list" }, children))));
}
BuyDescriptions.Item = BuyDescriptionsItem;
BuyDescriptions.ProItem = BuyDescriptionsProItem;
BuyDescriptions.Collaps = BuyDescriptionsCollapse;
//# sourceMappingURL=BuyDescriptions.js.map